const routes = {
  home: "/",
  register: "/register",
  login: "/login",
  contacts: "/contacts",
};
export default routes;
